import React, { useMemo } from 'react';
import { FunctionComponent } from 'react';
import { meetingSimpleSelectors } from '../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { MenuMembers } from './MenuMembers';
import { TaskMembers } from './TaskMembers';

import { IMembersProps } from './types';

export const Members: FunctionComponent<IMembersProps> = ({ menu, taskId, meetingId }) => {
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);
  const usersIds = useMemo(() => meeting && ([...meeting.shareWithIds, ...meeting.administratorIds] ?? []), [meeting]);

  const uniqueUserIds = Array.from(new Set(usersIds));

  return meeting && menu ? (
    <MenuMembers userIds={uniqueUserIds} taskId={taskId} />
  ) : (
    <TaskMembers userIds={uniqueUserIds} taskId={taskId} />
  );
};
